import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';

import _createGame from '@src/io/events_out/_createGame';

import _joinGame from '@src/io/events_out/_joinGame';
import _watchGame from '@src/io/events_out/_watchGame';
import _joinTournament from '@src/io/events_out/_joinTournament';
import _leaveTournament from '@src/io/events_out/_leaveTournament';
import { GameType } from '@src/lib/types';

import { clearEventQueue } from '@src/state/slices/slice_game';
import { GameState, TournamentState } from '@src/state/slices/types';

import TournamentRow from './TournamentRow';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  margin-top: 10pt;
  border: 2pt solid gray;
  padding: 5pt;

  overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;
`;

interface Props {
  games: GameState['games'];
  tournaments: TournamentState['tournaments'];
  gameTypes: GameType[];
  filterTournamentGames: boolean;
}

export default function TournamentList(props: Props) {
  const dispatch = _useDispatch();
  const playerMeta = _useSelector((state) => state.game.playerMeta);
  const playerId = playerMeta?.playerId || '';

  const joinGame = (gameId: string) => {
    dispatch(clearEventQueue());
    _joinGame(gameId);
  };

  const joinTournament = (tournamentId: string) => {
    _joinTournament(tournamentId);
  };

  const leaveTournament = (tournamentId: string) => {
    _leaveTournament(tournamentId);
  };

  const watchGame = (gameId: string) => {
    dispatch(clearEventQueue());
    _watchGame(gameId);
  };

  return (
    <Container>
      {Object.values(props.tournaments).map((tournament) => (
        <TournamentRow
          key={tournament.tournamentId}
          name={tournament.name}
          games={props.games}
          tournament={tournament}
          playerId={playerId}
          joinTournament={joinTournament}
          leaveTournament={leaveTournament}
          joinGame={joinGame}
          watchGame={watchGame}
          filterTournamentGames={props.filterTournamentGames}
        />
      ))}
    </Container>
  );
}
